import { DataService } from '../config/dataService/dataService_yerbis';

class serviceHelper {
  static async IlListesi() {
    const response = await DataService.get('/BaseMethod/GetilList');
    return response.data?.model ? response.data.model : [];
  }

  static async IlceListesi(ilId) {
    const response = await DataService.get(`/BaseMethod/GetilceList?ilId=${ilId}`);
    return response.data?.model ? response.data.model : [];
  }

  static async MahalleListesi(ilceId) {
    const response = await DataService.get(`/BaseMethod/GetMahalleList?ilceId=${ilceId}`);
    return response.data?.model ? response.data.model : [];
  }

  static async VergiDairesiListesi(ilId) {
    const response = await DataService.get(`/BaseMethod/GetVergiDaireList?ilId=${ilId}`);
    return response.data?.model ? response.data.model : [];
  }

  static async KurumNodeList() {
    const response = await DataService.post(`${process.env.REACT_APP_KURUM_NODE_LIST_ENDPOINT}`, {
      orderColumnAndDirection: '"IdInt"',
    });
    return response.data?.model ? response.data.model : [];
  }

  static async TanimTuruListesi(turId, ustVeriId) {
    const params = {};

    if (turId) {
      params.turId = turId;
    }

    if (ustVeriId) {
      params.ustVeriId = ustVeriId;
    }

    const response = await DataService.get('/TanimTur/TanimTuruListesiByTurIdAndUstVeriId', params);
    return response.data.model;
  }

  static async IlListesiDinamik() {
    const response = await DataService.get('/Api/GetilList');
    return response.data?.model ? response.data.model : [];
  }

  static async IlceListesiDinamik(ilId) {
    const response = await DataService.get(`/Api/GetilceList?ilId=${ilId}`);
    return response.data?.model ? response.data.model : [];
  }

  static async MahalleListesiDinamik(ilceId) {
    const response = await DataService.get(`/Api/GetMahalleList?ilceId=${ilceId}`);
    return response.data?.model ? response.data.model : [];
  }

  static async VergiDairesiListesiDinamik(ilId) {
    const response = await DataService.get(`/Api/GetVergiDaireList?ilId=${ilId}`);
    return response.data?.model ? response.data.model : [];
  }

  static async IlceListesiMultiSelect(ilId) {
    const response = await DataService.post(`${process.env.REACT_APP_PROJE_YONETIM_ILCE_GRUPLAMA_LIST_ENDPOINT}`, {
      ilNo: ilId,
    });
    return response.data?.model ? response.data.model : [];
  }

  static async MahalleListesiMultiSelect(ilceId) {
    const response = await DataService.post(`${process.env.REACT_APP_PROJE_YONETIM_MAHALLE_GRUPLAMA_LIST_ENDPOINT}`, {
      ilceNo: ilceId,
    });
    return response.data?.model ? response.data.model : [];
  }
}

export default serviceHelper;
